import { render } from "./HostNotifications.vue?vue&type=template&id=84255e88"
import script from "./HostNotifications.vue?vue&type=script&lang=js"
export * from "./HostNotifications.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__